<template>
<teleport to="#ohm">
  <transition name="Modal" appear>
    <component :is="tag || 'div'" v-if="open$" class="Modal t-miniscroll"
        v-bind="$attrs" :style="`--level: ${ level - 1}`" @click="onClick">
      <div class="Modal__wrapper" @click.self="onBackdrop">
        <div class="Modal__container">
          <slot v-bind="{ close, data: open$ !== true ? open$ : null }">
            <header v-if="$slots.header">
              <slot name="header" />
            </header>

            <slot name="body" />

            <footer v-if="$slots.footer">
              <slot name="footer" />
            </footer>
          </slot>
        </div>
      </div>
    </component>
  </transition>
</teleport>
</template>
<script>
import { preventScroll } from 'services/scroll';

let count = 0;

export default {
  inheritAttrs: false,
  emits: ['update:open', 'close', 'open'],

  data: () => ({
    open$$: false,
    level: 0,
  }),

  methods: {
    toggle (data = !this.open$) {
      // eslint-disable-next-line
      if (this.open$ && this.preventClose == true) {
        return;
      }

      const preventClosingClosed = !!this.open$$ === false && !!data === false;

      if (this.open !== undefined)
        this.$emit('update:open', data);
      else
        this.open$$ = data;

      if (!data) {
        if (!preventClosingClosed)
          this.$emit('close');
      }
      else
        this.$emit('open');
      return data;
    },

    onToggle (open = this.open) {
      count += open ? 1 : -1;
      if (open) {
        preventScroll(true);
        this.level = count;
      }
      if (count < 1)
        preventScroll(false);
    },

    onEscape (e) {
      if (e.keyCode === 27)
        this.close();
    },

    onBackdrop (e) {
      if (e.target === e.currentTarget && this.preventClose !== 'backdrop')
        this.close();
    },

    close () {
      this.toggle(false);
    },

    onClick (e) {
      if (e.target?.name === 'close-modal')
        this.close();
    },
  },

  computed: {
    open$ () {
      return this.open !== undefined ? this.open : this.open$$;
    },
  },

  watch: {
    open$: 'onToggle',
  },

  mounted () {
    if (this.open$)
      this.onToggle(true);
    document.addEventListener('keydown', this.onEscape);
  },

  unmounted () {
    document.removeEventListener('keydown', this.onEscape);
  },

  // props: {
  //   open: [Boolean, Object, Array],
  //   tag: [String, Object],
  //   preventClose: { type: [Boolean, String], default: false },
  // },
  props: ['open', 'tag', 'preventClose'],
};

</script>
<style>
.Modal {
  --z-index: var(--zi-modal, 2100);
  --level: 0;

  position: fixed;
  top: 0;
  left: 0;
  z-index: calc(var(--z-index) + var(--level));

  display: block;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  font-family: var(--font-family);

  background-color: rgba(0, 0, 0, .5);

  transition: opacity .3s ease;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    min-height: 100vh;
    padding: var(--page-pad);

    vertical-align: middle;
    /* pointer-events: none; */
    /* overflow-y: auto; */
  }

  & &__container {
    width: var(--modal-w, 640px);
    max-width: 100vw;
    /* margin: 0px auto; */
    /* padding: 20px 30px; */
    /* max-height: calc(100vh - var(--page-pad) * 2); */

    font-weight: normal;
    font-size: 14px;

    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);

    transition: all .3s ease;

    pointer-events: initial;
  }

  header {
    position: relative;

    padding: var(--page-pad);
    padding-bottom: calc(var(--main-pad) + 4px);

    background-color: var(--white);
    border-bottom: 1px solid var(--black-10);
    border-radius: 3px;
  }

  header h3 {
    position: sticky;
    top: 0;
    /* z-index: 10; */

    margin: 0;

    color: var(--black);
    font-weight: 500;
    font-size: 18px;

    background: #fffc;
    border-radius: 3px;
  }

  .Modal__body {
    position: relative;

    /* margin: 20px 0; */
    /* overflow-x: hidden; */
    padding: var(--page-pad);
    padding-top: var(--main-pad);
  }

  footer {
    position: relative;

    min-height: 64px;
    padding: 16px var(--page-pad);

    text-align: left;

    background-color: var(--white);
    border-top: 1px solid var(--black-10);
    border-radius: 3px;
  }

  & &__close {
    position: absolute;
    top: 0;
    right: 0;

    height: auto;
    padding: 10px;

    background-color: white;
    cursor: pointer;
    opacity: .5;

    &:hover {
      opacity: 1;
    }

    i {
      pointer-events: none;
    }
  }

  &.--scroll .Modal {
    &__container {
      display: flex;
      flex-direction: column;
      max-height: calc(100vh - 2 * var(--page-pad));
    }

    .Modal__body {
      overflow-y: auto;
    }
  }

  &.--wide .Modal {
    &__container {
      width: 100%;
      min-width: var(--modal-w);
      max-width: 1120px;
    }
  }

  &.--full-h .Modal {
    &__container {
      height: calc(100vh - 2 * var(--page-pad));
    }

    .Modal__body {
      flex-grow: 2;
    }
  }

  &.--max-full-h .Modal {
    &__container {
      max-height: calc(100vh - 2 * var(--page-pad));
    }
  }
}

.--testing .Modal { background-color: white }

.Modal-enter-from,
.Modal-leave-active { opacity: 0 }

.Modal-leave-active .Modal__container { transform: scale(1.1) }

.Modal-enter-from .Modal__container { transform: scale(.9) }
</style>
